/*
 * @Author: 小周
 * @Date: 2024-08-01 11:03:11
 * @LastEditTime: 2024-08-02 15:38:24
 * @LastEditors: MrZHLF
 * @Description: 常量 集合
 */

// 埋点项目名称
export const TRACK_H5_PROJECT_NAME = '2024baliaoyunhui'
export const ARTICLE_ID = '1819207876108488705'
